import React from "react";

function DashboardCard({
  title,
  num,
  icon,
  bgColor = "bg-white",
  textColor = "text-gray-700",
}) {
  return (
    <div
      className={`${bgColor} w-full sm:w-1/2 lg:w-1/4 h-28 rounded-xl shadow-sm border border-gray-100 transition-transform hover:scale-[1.01]`}
    >
      <div className="flex flex-col justify-between h-full px-5 py-4">
        <div className="text-2xl font-semibold text-gray-900">{num}</div>
        <div className="flex items-center space-x-2">
          <div className={`text-lg ${textColor}`}>{icon}</div>
          <span className="text-sm font-medium text-gray-500">{title}</span>
        </div>
      </div>
    </div>
  );
}

export default DashboardCard;
